// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2def254f","455":"113f8cdf","977":"78d65950"}[chunkId] + ".chunk.js";
};